exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".securitySettings-app .dnn-persona-bar-page-body .persona-bar-page-body {\n  min-height: 600px;\n}\n", ""]);

